export const userData = (state = {}, action) => {
  if (action.type === "USERDATA_CHANGE_INPUT") {
    return { ...state, [action.field]: action.value };
  } else if (action.type === "USER_DATA_LOADED") {
    return { ...state, ...action.data };
  }

  return state;
};
